import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import $session from "servicestack/session";

class SwatchCountPromptController {
  constructor(options, $state, $stateParams) {
    const $ctrl = this;
    basicController($ctrl);
    var model = ($ctrl.model = options.model);
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "Count...";
    $ctrl.statuses = ["Open", "Completed", "Fulfilled"];
    if (!model.count) {
      model.count = {
        countName: "",
        status: "Open",
        countType: model.countType || options.countType || "swatch"
      };
      if (model.customer) {
        model.count.retailerId = model.customer.id;
      }
    } else {
      if (model.count.retailerId) {
        model.customer = {
          id: model.count.retailerId,
          companyName: model.count.retailerCompanyName,
        };
      }
    }

    $ctrl.listQuery = new AutoQuery({
      url: "QuerySwatchLists.json",
      criteria: {
        listType: model.count.countType
      },
      autoLoad: true,
      onLoaded: (args) => {
        //if (!model.count.id) {
        //    $ctrl.model.count.listId = args.first.id;
        //}
      },
    });

    if ($ctrl.model.customer) {
      var retailerQuery = new AutoQuery({
        url: "QueryRetailers.json?Id=" + $ctrl.model.customer.id,
        orderBy: "CompanyName",
        autoLoad: true,
        onLoaded: (args) => {
          $ctrl.model.customer = args.first;
        },
      });
      $ctrl.locations = new AutoQuery({
        url:
          "QueryRetailerShippingLocations.json?retailerId=" +
          $ctrl.model.customer.id,
        orderBy: "Name",
        autoLoad: true,
        pageSize: 10,
      });
    }
  }

  findRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }

  selectRetailer(val) {
    const $ctrl = this;
    $ctrl.model.customer = val;
    var retailerQuery = new AutoQuery({
      url: "QueryRetailers.json?Id=" + $ctrl.model.customer.id,
      orderBy: "CompanyName",
      autoLoad: true,
      onLoaded: (args) => {
        $ctrl.model.customer = args.first;
      },
    });
    $ctrl.locations = new AutoQuery({
      url:
        "QueryRetailerShippingLocations.json?retailerId=" +
        $ctrl.model.customer.id,
      orderBy: "Name",
      autoLoad: true,
      onLoaded: (args) => {
        if (args.total == 1) {
          $ctrl.model.count.shipId = args.first.id;
        }
      },
    });
  }

  save(close) {
    const $ctrl = this;
    var tempCount = Object.assign({}, $ctrl.model.count);
    if ($ctrl.model.customer) {
      tempCount.retailerId = $ctrl.model.customer.id;
    }

    if ($ctrl.model.count.id) {
      $ctrl.bus
        .send("UpdateSwatchCount.json?jsconfig=ua,uaa", tempCount)
        .then(function (response) {
          $ctrl.$emit("swatchcountSaved", $ctrl);
          if (close) {
            $ctrl.$close($ctrl.model);
          }
        });
    } else {
      $ctrl.bus
        .send("CreateSwatchCount.json?jsconfig=ua,uaa", tempCount)
        .then(function (response) {
          $ctrl.$emit("swatchcountSaved", $ctrl);
          $ctrl.model.count.id = response.data.id;
          $ctrl.$state.transitionTo("swatch.editcount", {
            countId: response.data.id,
          });
          if (close) {
            $ctrl.$close($ctrl.model);
          }
        });
    }
  }

  submit() {
    const $ctrl = this;
    $ctrl.save(true);
  }

  delete() {
    const $ctrl = this;
    $ctrl.$close($ctrl.model);
    return modals
      .confirm("Are you sure?", "Delete Count")
      .result.then(function () {
        $ctrl.bus
          .send("DeleteSwatchCount.json", $ctrl.model.count)
          .then(function (response) {
            $ctrl.$emit("swatchcountDeleted", $ctrl);
          });
      });
  }

  dismiss() {
    const $ctrl = this;
    //$ctrl.$emit('activitySaved', $ctrl);
    $ctrl.$dismiss();
  }
}

export default SwatchCountPromptController;
